<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col items-center px-6 lg:px-0 py-17.75 col-span-full md:col-start-2 md:col-end-8 lg:col-end-12"
    >
      <section class="flex flex-col items-center px-3 lg:px-0">
        <section class="flex gap-x-4 items-center">
          <div class="w-14 h-14 bg-gray-400 rounded-full" />
          <article>
              <p class="text-xl font-bold" v-text="'Pedro Bonilla'"/>
              <p class="pt-1" v-text="'Diseñador Gráfico'"/>
          </article>
        </section>
        <p
          class="lg:px-20-px pt-6 text-center text-xl max-w-182.5"
          v-text="
            'Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.'
          "
        />
        <section class="pt-12 flex justify-center items-center gap-x-10">
          <div class="w-10 h-40-px rounded-full bg-gray-400"/>
          <div class="w-10 h-40-px rounded-full bg-gray-400" />
          <div class="w-10 h-40-px rounded-full bg-gray-400" />
        </section>
      </section>
    </section>
  </section>
</template>
<script>
import utilsMixin from "../mixins/utilsMixin";
export default {
  mixins: [utilsMixin],
  props:{
    withBorder:{
      default: true
    }
  }
};
</script>
